/* GENERATED by scripts/sync-foundry-launcher.mjs. Do not edit.

   Foundry's exact class names, so the vendored stylesheet applies by
   construction. A part named here is a part Foundry ships; anything else is
   ours and belongs in the app's own stylesheet.

   A key spelled "part@hash" means that part name exists in more than one of
   the namespace's CSS modules and there is no unambiguous answer — pick the
   module the element belongs to. See the script header. */

/*
  control-panel-components — 2 CSS module(s):
    fz2z6k    office-icon, select-button, tooltip-target
    q5g46y    entity-with-icon, icon
*/
export const controlPanelComponents = {
  "entity-with-icon": "control-panel-components__entity-with-icon__q5g46y",
  "icon": "control-panel-components__icon__q5g46y",
  "office-icon": "control-panel-components__office-icon__fz2z6k",
  "select-button": "control-panel-components__select-button__fz2z6k",
  "tooltip-target": "control-panel-components__tooltip-target__fz2z6k",
} as const;

/*
  control-panel-app — 8 CSS module(s):
    1o33bj1   action, card, gray, icon-background, resources-container, text-section, title, turquoise, violet
    1wd12z    container, header, search-bar, subtitle, title-and-description, title-and-image, title-container
    femj1l    container, default-domain, default-tag, divider, list, org-row, title
    fay7tg    container, user-sidebar-item, user-sidebar-item-active
    1py9ndi   favorite-frequent-favorites-container, favorites-container
    27r2rw    sidebar-item-icon
    1gh3j8l   header
    1rfjnmb   links-container
*/
export const controlPanelApp = {
  "action": "control-panel-app__action__1o33bj1",
  "card": "control-panel-app__card__1o33bj1",
  "container@1wd12z": "control-panel-app__container__1wd12z",
  "container@fay7tg": "control-panel-app__container__fay7tg",
  "container@femj1l": "control-panel-app__container__femj1l",
  "default-domain": "control-panel-app__default-domain__femj1l",
  "default-tag": "control-panel-app__default-tag__femj1l",
  "divider": "control-panel-app__divider__femj1l",
  "favorite-frequent-favorites-container": "control-panel-app__favorite-frequent-favorites-container__1py9ndi",
  "favorites-container": "control-panel-app__favorites-container__1py9ndi",
  "gray": "control-panel-app__gray__1o33bj1",
  "header@1gh3j8l": "control-panel-app__header__1gh3j8l",
  "header@1wd12z": "control-panel-app__header__1wd12z",
  "icon-background": "control-panel-app__icon-background__1o33bj1",
  "links-container": "control-panel-app__links-container__1rfjnmb",
  "list": "control-panel-app__list__femj1l",
  "org-row": "control-panel-app__org-row__femj1l",
  "resources-container": "control-panel-app__resources-container__1o33bj1",
  "search-bar": "control-panel-app__search-bar__1wd12z",
  "sidebar-item-icon": "control-panel-app__sidebar-item-icon__27r2rw",
  "subtitle": "control-panel-app__subtitle__1wd12z",
  "text-section": "control-panel-app__text-section__1o33bj1",
  "title-and-description": "control-panel-app__title-and-description__1wd12z",
  "title-and-image": "control-panel-app__title-and-image__1wd12z",
  "title-container": "control-panel-app__title-container__1wd12z",
  "title@1o33bj1": "control-panel-app__title__1o33bj1",
  "title@femj1l": "control-panel-app__title__femj1l",
  "turquoise": "control-panel-app__turquoise__1o33bj1",
  "user-sidebar-item": "control-panel-app__user-sidebar-item__fay7tg",
  "user-sidebar-item-active": "control-panel-app__user-sidebar-item-active__fay7tg",
  "violet": "control-panel-app__violet__1o33bj1",
} as const;

/*
  control-panel-shell — 12 CSS module(s):
    t7drfl    container, cp-icon, divider, header, new-feature-overlay, new-feature-wrapper, picker, settings, settings-content, settings-sidebar, settings-wrapper, slash, space-divider, space-picker, title
    14nxjnf   current-extension, favorites-header, sidebar, sidebar-footer-section, sidebar-no-favorites, sidebar-no-favorites-wrapper, sidebar-section, sidebar-shortcut, sidebar-tabs, text-container, view-all-button
    1k9nael   active-button, container, muted-button, select-target, single-item
    cti876    anchor, card, card-header, title, title-container
    1qk4dn0   sidebar-item, sidebar-item-icon, sidebar-item-label, sidebar-item-name
    mo67cn    new-feature-indicator, sidebar-link, sidebar-link-anchor, sidebar-link-selected
    17uyhwb   sidebar-group, sidebar-group-header, sidebar-group-name, sidebar-group-tabs
    xq8jxp    enrollment-picker-name, muted-icon, picker-wrapper
    8yl7k8    active-button, muted-button
    7e378p    favorite-star, favorite-star-wrapper
    vho1ur    lock-tooltip, tag
    p53w7e    header
*/
export const controlPanelShell = {
  "active-button@1k9nael": "control-panel-shell__active-button__1k9nael",
  "active-button@8yl7k8": "control-panel-shell__active-button__8yl7k8",
  "anchor": "control-panel-shell__anchor__cti876",
  "card": "control-panel-shell__card__cti876",
  "card-header": "control-panel-shell__card-header__cti876",
  "container@1k9nael": "control-panel-shell__container__1k9nael",
  "container@t7drfl": "control-panel-shell__container__t7drfl",
  "cp-icon": "control-panel-shell__cp-icon__t7drfl",
  "current-extension": "control-panel-shell__current-extension__14nxjnf",
  "divider": "control-panel-shell__divider__t7drfl",
  "enrollment-picker-name": "control-panel-shell__enrollment-picker-name__xq8jxp",
  "favorite-star": "control-panel-shell__favorite-star__7e378p",
  "favorite-star-wrapper": "control-panel-shell__favorite-star-wrapper__7e378p",
  "favorites-header": "control-panel-shell__favorites-header__14nxjnf",
  "header@p53w7e": "control-panel-shell__header__p53w7e",
  "header@t7drfl": "control-panel-shell__header__t7drfl",
  "lock-tooltip": "control-panel-shell__lock-tooltip__vho1ur",
  "muted-button@1k9nael": "control-panel-shell__muted-button__1k9nael",
  "muted-button@8yl7k8": "control-panel-shell__muted-button__8yl7k8",
  "muted-icon": "control-panel-shell__muted-icon__xq8jxp",
  "new-feature-indicator": "control-panel-shell__new-feature-indicator__mo67cn",
  "new-feature-overlay": "control-panel-shell__new-feature-overlay__t7drfl",
  "new-feature-wrapper": "control-panel-shell__new-feature-wrapper__t7drfl",
  "picker": "control-panel-shell__picker__t7drfl",
  "picker-wrapper": "control-panel-shell__picker-wrapper__xq8jxp",
  "select-target": "control-panel-shell__select-target__1k9nael",
  "settings": "control-panel-shell__settings__t7drfl",
  "settings-content": "control-panel-shell__settings-content__t7drfl",
  "settings-sidebar": "control-panel-shell__settings-sidebar__t7drfl",
  "settings-wrapper": "control-panel-shell__settings-wrapper__t7drfl",
  "sidebar": "control-panel-shell__sidebar__14nxjnf",
  "sidebar-footer-section": "control-panel-shell__sidebar-footer-section__14nxjnf",
  "sidebar-group": "control-panel-shell__sidebar-group__17uyhwb",
  "sidebar-group-header": "control-panel-shell__sidebar-group-header__17uyhwb",
  "sidebar-group-name": "control-panel-shell__sidebar-group-name__17uyhwb",
  "sidebar-group-tabs": "control-panel-shell__sidebar-group-tabs__17uyhwb",
  "sidebar-item": "control-panel-shell__sidebar-item__1qk4dn0",
  "sidebar-item-icon": "control-panel-shell__sidebar-item-icon__1qk4dn0",
  "sidebar-item-label": "control-panel-shell__sidebar-item-label__1qk4dn0",
  "sidebar-item-name": "control-panel-shell__sidebar-item-name__1qk4dn0",
  "sidebar-link": "control-panel-shell__sidebar-link__mo67cn",
  "sidebar-link-anchor": "control-panel-shell__sidebar-link-anchor__mo67cn",
  "sidebar-link-selected": "control-panel-shell__sidebar-link-selected__mo67cn",
  "sidebar-no-favorites": "control-panel-shell__sidebar-no-favorites__14nxjnf",
  "sidebar-no-favorites-wrapper": "control-panel-shell__sidebar-no-favorites-wrapper__14nxjnf",
  "sidebar-section": "control-panel-shell__sidebar-section__14nxjnf",
  "sidebar-shortcut": "control-panel-shell__sidebar-shortcut__14nxjnf",
  "sidebar-tabs": "control-panel-shell__sidebar-tabs__14nxjnf",
  "single-item": "control-panel-shell__single-item__1k9nael",
  "slash": "control-panel-shell__slash__t7drfl",
  "space-divider": "control-panel-shell__space-divider__t7drfl",
  "space-picker": "control-panel-shell__space-picker__t7drfl",
  "tag": "control-panel-shell__tag__vho1ur",
  "text-container": "control-panel-shell__text-container__14nxjnf",
  "title-container": "control-panel-shell__title-container__cti876",
  "title@cti876": "control-panel-shell__title__cti876",
  "title@t7drfl": "control-panel-shell__title__t7drfl",
  "view-all-button": "control-panel-shell__view-all-button__14nxjnf",
} as const;

/*
  new-feature-components — 2 CSS module(s):
    1p71xz6   overlay, target, unfocused-overlay
    1oub2qz   indicator
*/
export const newFeatureComponents = {
  "indicator": "new-feature-components__indicator__1oub2qz",
  "overlay": "new-feature-components__overlay__1p71xz6",
  "target": "new-feature-components__target__1p71xz6",
  "unfocused-overlay": "new-feature-components__unfocused-overlay__1p71xz6",
} as const;

/*
  favorite-star — 1 CSS module(s):
    1tcgvet   favorite-star, favorite-star-animation
*/
export const favoriteStar = {
  "favorite-star": "favorite-star__favorite-star__1tcgvet",
  "favorite-star-animation": "favorite-star__favorite-star-animation__1tcgvet",
} as const;

/*
  loading-bar — 1 CSS module(s):
    6r81gx    loading-bar
*/
export const loadingBar = {
  "loading-bar": "loading-bar__loading-bar__6r81gx",
} as const;

/*
  workspace-banner-components — 3 CSS module(s):
    bhu6bd    classification-banner, primary, show-when-printing, top
    10dv3w9   wrapper
    1ekyavf   banner
*/
export const workspaceBannerComponents = {
  "banner": "workspace-banner-components__banner__1ekyavf",
  "classification-banner": "workspace-banner-components__classification-banner__bhu6bd",
  "primary": "workspace-banner-components__primary__bhu6bd",
  "show-when-printing": "workspace-banner-components__show-when-printing__bhu6bd",
  "top": "workspace-banner-components__top__bhu6bd",
  "wrapper": "workspace-banner-components__wrapper__10dv3w9",
} as const;

/*
  resource-icon — 5 CSS module(s):
    97od5q    agent-studio-app, ai-fde-app, aip-analyst-app, aip-assist-tutorials-app, aip-autopilot-app, aip-document-intelligence-app, aip-showcase, approvals-app, arrow-workbook-app, artifacts-app, automation-app, carbon-workspace-app, checkpoints-app, cipher-channel-app, code-app, code-workspace-app, contour-analysis-app, control-panel-app, custom-widgets-app, data-connection-app, data-health-app, default-app, deployed-application-app, dev-console-app, developer-branching-app, evals-app, flow-capture-app, form-app, foundry-rules-app, fusion-app, hyperauto-app, inference-app, insight-app, job-tracker-app, linter-app, logic-app, machinery-app, marketplace-app, marketplace-packaging-app, mcp-hub-app, model-app, model-catalog-app, model-studio-app, modeling-objective-app, monocle-graph-app, notepad-app, notifications-app, object-search-app, ontology-objecttype-app, pilot-app, pipeline-builder-graph-app, preparation-app, quiver-app, resource-management-app, restricted-view-app, retention-app, sddi-app, slate-document-app, solution-design-app, sql-studio-app, structured-dataset-app, symbols-management-app, templates-app, time-series-catalog-app, training-app, upgrade-assistant-app, value-types-app, vertex-graph-app, vortex-map-app, vortex-map-layer-app, workflow-builder-app, workflow-builder-write-mode-app, workshop-module-app
    lpbkv6    control-panel-app
    zvxzim    app-icon-view
    1ca0yce   artifact-repository
    1dwkfej   resource-icon-view
*/
export const resourceIcon = {
  "agent-studio-app": "resource-icon__agent-studio-app__97od5q",
  "ai-fde-app": "resource-icon__ai-fde-app__97od5q",
  "aip-analyst-app": "resource-icon__aip-analyst-app__97od5q",
  "aip-assist-tutorials-app": "resource-icon__aip-assist-tutorials-app__97od5q",
  "aip-autopilot-app": "resource-icon__aip-autopilot-app__97od5q",
  "aip-document-intelligence-app": "resource-icon__aip-document-intelligence-app__97od5q",
  "aip-showcase": "resource-icon__aip-showcase__97od5q",
  "app-icon-view": "resource-icon__app-icon-view__zvxzim",
  "approvals-app": "resource-icon__approvals-app__97od5q",
  "arrow-workbook-app": "resource-icon__arrow-workbook-app__97od5q",
  "artifact-repository": "resource-icon__artifact-repository__1ca0yce",
  "artifacts-app": "resource-icon__artifacts-app__97od5q",
  "automation-app": "resource-icon__automation-app__97od5q",
  "carbon-workspace-app": "resource-icon__carbon-workspace-app__97od5q",
  "checkpoints-app": "resource-icon__checkpoints-app__97od5q",
  "cipher-channel-app": "resource-icon__cipher-channel-app__97od5q",
  "code-app": "resource-icon__code-app__97od5q",
  "code-workspace-app": "resource-icon__code-workspace-app__97od5q",
  "contour-analysis-app": "resource-icon__contour-analysis-app__97od5q",
  "control-panel-app@97od5q": "resource-icon__control-panel-app__97od5q",
  "control-panel-app@lpbkv6": "resource-icon__control-panel-app__lpbkv6",
  "custom-widgets-app": "resource-icon__custom-widgets-app__97od5q",
  "data-connection-app": "resource-icon__data-connection-app__97od5q",
  "data-health-app": "resource-icon__data-health-app__97od5q",
  "default-app": "resource-icon__default-app__97od5q",
  "deployed-application-app": "resource-icon__deployed-application-app__97od5q",
  "dev-console-app": "resource-icon__dev-console-app__97od5q",
  "developer-branching-app": "resource-icon__developer-branching-app__97od5q",
  "evals-app": "resource-icon__evals-app__97od5q",
  "flow-capture-app": "resource-icon__flow-capture-app__97od5q",
  "form-app": "resource-icon__form-app__97od5q",
  "foundry-rules-app": "resource-icon__foundry-rules-app__97od5q",
  "fusion-app": "resource-icon__fusion-app__97od5q",
  "hyperauto-app": "resource-icon__hyperauto-app__97od5q",
  "inference-app": "resource-icon__inference-app__97od5q",
  "insight-app": "resource-icon__insight-app__97od5q",
  "job-tracker-app": "resource-icon__job-tracker-app__97od5q",
  "linter-app": "resource-icon__linter-app__97od5q",
  "logic-app": "resource-icon__logic-app__97od5q",
  "machinery-app": "resource-icon__machinery-app__97od5q",
  "marketplace-app": "resource-icon__marketplace-app__97od5q",
  "marketplace-packaging-app": "resource-icon__marketplace-packaging-app__97od5q",
  "mcp-hub-app": "resource-icon__mcp-hub-app__97od5q",
  "model-app": "resource-icon__model-app__97od5q",
  "model-catalog-app": "resource-icon__model-catalog-app__97od5q",
  "model-studio-app": "resource-icon__model-studio-app__97od5q",
  "modeling-objective-app": "resource-icon__modeling-objective-app__97od5q",
  "monocle-graph-app": "resource-icon__monocle-graph-app__97od5q",
  "notepad-app": "resource-icon__notepad-app__97od5q",
  "notifications-app": "resource-icon__notifications-app__97od5q",
  "object-search-app": "resource-icon__object-search-app__97od5q",
  "ontology-objecttype-app": "resource-icon__ontology-objecttype-app__97od5q",
  "pilot-app": "resource-icon__pilot-app__97od5q",
  "pipeline-builder-graph-app": "resource-icon__pipeline-builder-graph-app__97od5q",
  "preparation-app": "resource-icon__preparation-app__97od5q",
  "quiver-app": "resource-icon__quiver-app__97od5q",
  "resource-icon-view": "resource-icon__resource-icon-view__1dwkfej",
  "resource-management-app": "resource-icon__resource-management-app__97od5q",
  "restricted-view-app": "resource-icon__restricted-view-app__97od5q",
  "retention-app": "resource-icon__retention-app__97od5q",
  "sddi-app": "resource-icon__sddi-app__97od5q",
  "slate-document-app": "resource-icon__slate-document-app__97od5q",
  "solution-design-app": "resource-icon__solution-design-app__97od5q",
  "sql-studio-app": "resource-icon__sql-studio-app__97od5q",
  "structured-dataset-app": "resource-icon__structured-dataset-app__97od5q",
  "symbols-management-app": "resource-icon__symbols-management-app__97od5q",
  "templates-app": "resource-icon__templates-app__97od5q",
  "time-series-catalog-app": "resource-icon__time-series-catalog-app__97od5q",
  "training-app": "resource-icon__training-app__97od5q",
  "upgrade-assistant-app": "resource-icon__upgrade-assistant-app__97od5q",
  "value-types-app": "resource-icon__value-types-app__97od5q",
  "vertex-graph-app": "resource-icon__vertex-graph-app__97od5q",
  "vortex-map-app": "resource-icon__vortex-map-app__97od5q",
  "vortex-map-layer-app": "resource-icon__vortex-map-layer-app__97od5q",
  "workflow-builder-app": "resource-icon__workflow-builder-app__97od5q",
  "workflow-builder-write-mode-app": "resource-icon__workflow-builder-write-mode-app__97od5q",
  "workshop-module-app": "resource-icon__workshop-module-app__97od5q",
} as const;

/*
  control-panel-internal-components — 9 CSS module(s):
    iz3ajq    active, anchor-links, bar, dot, dot-container, entry, guide
    jcdwtx    actions, container, divider, icon-container, text, title
    112aovk   content-card, content-container, divider, title-container, title-left-container, title-right-container
    c9tkov    search-bar, search-bar-icon, search-bar-icon-and-placeholder, search-bar-shortcut-text, search-bar-text
    1fi1v2z   container, details, has-tabs, header, title
    1hrn1e4   add-button-container, card, search-input, subheader, title
    1sdv7qt   actions, description, item, text, title
    9tndr6    content-card, content-container, title-container, title-text
    c0irjv    divider, tab, tabs
*/
export const controlPanelInternalComponents = {
  "actions@1sdv7qt": "control-panel-internal-components__actions__1sdv7qt",
  "actions@jcdwtx": "control-panel-internal-components__actions__jcdwtx",
  "active": "control-panel-internal-components__active__iz3ajq",
  "add-button-container": "control-panel-internal-components__add-button-container__1hrn1e4",
  "anchor-links": "control-panel-internal-components__anchor-links__iz3ajq",
  "bar": "control-panel-internal-components__bar__iz3ajq",
  "card": "control-panel-internal-components__card__1hrn1e4",
  "container@1fi1v2z": "control-panel-internal-components__container__1fi1v2z",
  "container@jcdwtx": "control-panel-internal-components__container__jcdwtx",
  "content-card@112aovk": "control-panel-internal-components__content-card__112aovk",
  "content-card@9tndr6": "control-panel-internal-components__content-card__9tndr6",
  "content-container@112aovk": "control-panel-internal-components__content-container__112aovk",
  "content-container@9tndr6": "control-panel-internal-components__content-container__9tndr6",
  "description": "control-panel-internal-components__description__1sdv7qt",
  "details": "control-panel-internal-components__details__1fi1v2z",
  "divider@112aovk": "control-panel-internal-components__divider__112aovk",
  "divider@c0irjv": "control-panel-internal-components__divider__c0irjv",
  "divider@jcdwtx": "control-panel-internal-components__divider__jcdwtx",
  "dot": "control-panel-internal-components__dot__iz3ajq",
  "dot-container": "control-panel-internal-components__dot-container__iz3ajq",
  "entry": "control-panel-internal-components__entry__iz3ajq",
  "guide": "control-panel-internal-components__guide__iz3ajq",
  "has-tabs": "control-panel-internal-components__has-tabs__1fi1v2z",
  "header": "control-panel-internal-components__header__1fi1v2z",
  "icon-container": "control-panel-internal-components__icon-container__jcdwtx",
  "item": "control-panel-internal-components__item__1sdv7qt",
  "search-bar": "control-panel-internal-components__search-bar__c9tkov",
  "search-bar-icon": "control-panel-internal-components__search-bar-icon__c9tkov",
  "search-bar-icon-and-placeholder": "control-panel-internal-components__search-bar-icon-and-placeholder__c9tkov",
  "search-bar-shortcut-text": "control-panel-internal-components__search-bar-shortcut-text__c9tkov",
  "search-bar-text": "control-panel-internal-components__search-bar-text__c9tkov",
  "search-input": "control-panel-internal-components__search-input__1hrn1e4",
  "subheader": "control-panel-internal-components__subheader__1hrn1e4",
  "tab": "control-panel-internal-components__tab__c0irjv",
  "tabs": "control-panel-internal-components__tabs__c0irjv",
  "text@1sdv7qt": "control-panel-internal-components__text__1sdv7qt",
  "text@jcdwtx": "control-panel-internal-components__text__jcdwtx",
  "title-container@112aovk": "control-panel-internal-components__title-container__112aovk",
  "title-container@9tndr6": "control-panel-internal-components__title-container__9tndr6",
  "title-left-container": "control-panel-internal-components__title-left-container__112aovk",
  "title-right-container": "control-panel-internal-components__title-right-container__112aovk",
  "title-text": "control-panel-internal-components__title-text__9tndr6",
  "title@1fi1v2z": "control-panel-internal-components__title__1fi1v2z",
  "title@1hrn1e4": "control-panel-internal-components__title__1hrn1e4",
  "title@1sdv7qt": "control-panel-internal-components__title__1sdv7qt",
  "title@jcdwtx": "control-panel-internal-components__title__jcdwtx",
} as const;

/*
  user-account-menu — 1 CSS module(s):
    1uasynl   account-picture-wrapper, user-item
*/
export const userAccountMenu = {
  "account-picture-wrapper": "user-account-menu__account-picture-wrapper__1uasynl",
  "user-item": "user-account-menu__user-item__1uasynl",
} as const;

/*
  all-settings-extension — 1 CSS module(s):
    1ndwea2   anchor-link-container, content, disabled-heading, entity-icon, extension-card-list, extension-container, extension-group, header, header-content, header-wrapper, icon-divider, icons, info-icon, information, no-margin, select-on-hover, title-and-switch, two-col-grid, wrapper
*/
export const allSettingsExtension = {
  "anchor-link-container": "all-settings-extension__anchor-link-container__1ndwea2",
  "content": "all-settings-extension__content__1ndwea2",
  "disabled-heading": "all-settings-extension__disabled-heading__1ndwea2",
  "entity-icon": "all-settings-extension__entity-icon__1ndwea2",
  "extension-card-list": "all-settings-extension__extension-card-list__1ndwea2",
  "extension-container": "all-settings-extension__extension-container__1ndwea2",
  "extension-group": "all-settings-extension__extension-group__1ndwea2",
  "header": "all-settings-extension__header__1ndwea2",
  "header-content": "all-settings-extension__header-content__1ndwea2",
  "header-wrapper": "all-settings-extension__header-wrapper__1ndwea2",
  "icon-divider": "all-settings-extension__icon-divider__1ndwea2",
  "icons": "all-settings-extension__icons__1ndwea2",
  "info-icon": "all-settings-extension__info-icon__1ndwea2",
  "information": "all-settings-extension__information__1ndwea2",
  "no-margin": "all-settings-extension__no-margin__1ndwea2",
  "select-on-hover": "all-settings-extension__select-on-hover__1ndwea2",
  "title-and-switch": "all-settings-extension__title-and-switch__1ndwea2",
  "two-col-grid": "all-settings-extension__two-col-grid__1ndwea2",
  "wrapper": "all-settings-extension__wrapper__1ndwea2",
} as const;

/*
  multipass-principal-components — 2 CSS module(s):
    14u6trh   principal-avatar, principal-avatar-content, you-avatar
    1vh16tf   principal-avatars-list
*/
export const multipassPrincipalComponents = {
  "principal-avatar": "multipass-principal-components__principal-avatar__14u6trh",
  "principal-avatar-content": "multipass-principal-components__principal-avatar-content__14u6trh",
  "principal-avatars-list": "multipass-principal-components__principal-avatars-list__1vh16tf",
  "you-avatar": "multipass-principal-components__you-avatar__14u6trh",
} as const;

/*
  control-panel-extension-admin-permissions — 10 CSS module(s):
    1jgkrwc   actions-container, avatars, card-header, description, role-content, role-details
    1cyp60a   all-roles, main-section, page, roles-sections
    13m7j10   roles-filter, searchbar
    19ylwmx   details-section, details-section-header
    gvcg23    side-panel
    k8gbz1    placeholder
    vchvs6    card
    19cmpxv   info-callout
    1mrz9pa   avatarContainer
    1iute9b   roles-list
*/
export const controlPanelExtensionAdminPermissions = {
  "actions-container": "control-panel-extension-admin-permissions__actions-container__1jgkrwc",
  "all-roles": "control-panel-extension-admin-permissions__all-roles__1cyp60a",
  "avatarContainer": "control-panel-extension-admin-permissions__avatarContainer__1mrz9pa",
  "avatars": "control-panel-extension-admin-permissions__avatars__1jgkrwc",
  "card": "control-panel-extension-admin-permissions__card__vchvs6",
  "card-header": "control-panel-extension-admin-permissions__card-header__1jgkrwc",
  "description": "control-panel-extension-admin-permissions__description__1jgkrwc",
  "details-section": "control-panel-extension-admin-permissions__details-section__19ylwmx",
  "details-section-header": "control-panel-extension-admin-permissions__details-section-header__19ylwmx",
  "info-callout": "control-panel-extension-admin-permissions__info-callout__19cmpxv",
  "main-section": "control-panel-extension-admin-permissions__main-section__1cyp60a",
  "page": "control-panel-extension-admin-permissions__page__1cyp60a",
  "placeholder": "control-panel-extension-admin-permissions__placeholder__k8gbz1",
  "role-content": "control-panel-extension-admin-permissions__role-content__1jgkrwc",
  "role-details": "control-panel-extension-admin-permissions__role-details__1jgkrwc",
  "roles-filter": "control-panel-extension-admin-permissions__roles-filter__13m7j10",
  "roles-list": "control-panel-extension-admin-permissions__roles-list__1iute9b",
  "roles-sections": "control-panel-extension-admin-permissions__roles-sections__1cyp60a",
  "searchbar": "control-panel-extension-admin-permissions__searchbar__13m7j10",
  "side-panel": "control-panel-extension-admin-permissions__side-panel__gvcg23",
} as const;

/*
  application-access-extension — 12 CSS module(s):
    1y6aoc5   app-description, app-name, app-title, disabled, icon, icon-container, main, right-container, row, row-container
    bsee3d    app-description, app-name, app-title, content-card, icon, icon-container, main, right-container, row, row-container
    8k4wy0    anchor-link-container, border-top, bulk-mode, main-content, main-content-with-links, main-content-wrapper
    173zrsy   icon, title, tooltip-target
    unlkji    categories, category-description
    1nuo8e8   bulk-mode-toggle, container
    1bsqamj   tag
    l7a0cp    tag-with-tooltip
    5ugmkd    card
    hf73mm    no-manage
    r4sq1l    groups
    1a74yie   page
*/
export const applicationAccessExtension = {
  "anchor-link-container": "application-access-extension__anchor-link-container__8k4wy0",
  "app-description@1y6aoc5": "application-access-extension__app-description__1y6aoc5",
  "app-description@bsee3d": "application-access-extension__app-description__bsee3d",
  "app-name@1y6aoc5": "application-access-extension__app-name__1y6aoc5",
  "app-name@bsee3d": "application-access-extension__app-name__bsee3d",
  "app-title@1y6aoc5": "application-access-extension__app-title__1y6aoc5",
  "app-title@bsee3d": "application-access-extension__app-title__bsee3d",
  "border-top": "application-access-extension__border-top__8k4wy0",
  "bulk-mode": "application-access-extension__bulk-mode__8k4wy0",
  "bulk-mode-toggle": "application-access-extension__bulk-mode-toggle__1nuo8e8",
  "card": "application-access-extension__card__5ugmkd",
  "categories": "application-access-extension__categories__unlkji",
  "category-description": "application-access-extension__category-description__unlkji",
  "container": "application-access-extension__container__1nuo8e8",
  "content-card": "application-access-extension__content-card__bsee3d",
  "disabled": "application-access-extension__disabled__1y6aoc5",
  "groups": "application-access-extension__groups__r4sq1l",
  "icon-container@1y6aoc5": "application-access-extension__icon-container__1y6aoc5",
  "icon-container@bsee3d": "application-access-extension__icon-container__bsee3d",
  "icon@173zrsy": "application-access-extension__icon__173zrsy",
  "icon@1y6aoc5": "application-access-extension__icon__1y6aoc5",
  "icon@bsee3d": "application-access-extension__icon__bsee3d",
  "main-content": "application-access-extension__main-content__8k4wy0",
  "main-content-with-links": "application-access-extension__main-content-with-links__8k4wy0",
  "main-content-wrapper": "application-access-extension__main-content-wrapper__8k4wy0",
  "main@1y6aoc5": "application-access-extension__main__1y6aoc5",
  "main@bsee3d": "application-access-extension__main__bsee3d",
  "no-manage": "application-access-extension__no-manage__hf73mm",
  "page": "application-access-extension__page__1a74yie",
  "right-container@1y6aoc5": "application-access-extension__right-container__1y6aoc5",
  "right-container@bsee3d": "application-access-extension__right-container__bsee3d",
  "row-container@1y6aoc5": "application-access-extension__row-container__1y6aoc5",
  "row-container@bsee3d": "application-access-extension__row-container__bsee3d",
  "row@1y6aoc5": "application-access-extension__row__1y6aoc5",
  "row@bsee3d": "application-access-extension__row__bsee3d",
  "tag": "application-access-extension__tag__1bsqamj",
  "tag-with-tooltip": "application-access-extension__tag-with-tooltip__l7a0cp",
  "title": "application-access-extension__title__173zrsy",
  "tooltip-target": "application-access-extension__tooltip-target__173zrsy",
} as const;

